import PropTypes from 'prop-types';
import React from 'react';

const EditIcon = ({ color }) => (
  <svg width="76" height="76" viewBox="0 0 76 76" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd" clipRule="evenodd" d="M55.48 4.02L51.555 8.04L59.758 16.242L67.96 24.445L71.98 20.52C74.191 18.361 76 15.66 76 14.518C76 11.824 64.13 0 61.426 0C60.315 0 57.639 1.809 55.48 4.02ZM22.742 36.758L0 59.516V67.758V76H8.258H16.516L39.492 53.008L62.468 30.015L54.508 22.008C50.129 17.603 46.308 14 46.015 14C45.723 14 35.25 24.241 22.742 36.758Z" fill={color} />
  </svg>

);

EditIcon.propTypes = {
  color: PropTypes.string.isRequired,
};

export default EditIcon;
